interface LinoOption {
    id: number;
    state: string;
    title: string;
    productImageUrl: string;
}

export const LINO_OPTIONS: LinoOption[] = [
    {
        state: '-1',
        title: 'Select Your Council Name',
        productImageUrl: `https://dfstatic.com/images/products/full/451971pid88937.png`,
        id: -1,
    },
    {
        state: 'Alabama',
        title: 'Girl Scouts of North-Central Alabama',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-NorthCentralAlabama-autograph600.png',
        id: 27051,
    },
    {
        state: 'Alabama',
        title: 'Girl Scouts of Southern Alabama',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-SouthernAlabama-autograph600.png',
        id: 27052,
    },
    {
        state: 'Alaska',
        title: 'Girl Scouts of Alaska',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-Alaska-autograph600.png',
        id: 27053,
    },
    {
        state: 'Alaska',
        title: 'Farthest North Girl Scout Council',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-FarthestNorthCouncil-autograph600.png',
        id: 27054,
    },
    {
        state: 'Arizona',
        title: 'Girl Scouts–Arizona Cactus-Pine Council',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-ArizonaCactusPine-autograph600.png',
        id: 27055,
    },
    {
        state: 'Arizona',
        title: 'Girl Scouts of Southern Arizona',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-SouthernArizona-autograph600.png',
        id: 27056,
    },
    {
        state: 'Arkansas',
        title: 'Girl Scouts–Diamonds of Arkansas, Oklahoma and Texas',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-DiamondsOfArkansasOklahomaAndTexas-autograph600.png',
        id: 27057,
    },
    {
        state: 'California',
        title: "Girl Scouts of California's Central Coast",
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-CaliforniasCentralCoast-autograph600.png',
        id: 27058,
    },
    {
        state: 'California',
        title: 'Girl Scouts of Central California South',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-CentralCaliforniaSouth-autograph600.png',
        id: 27059,
    },
    {
        state: 'California',
        title: 'Girl Scouts of Greater Los Angeles',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-GreaterLosAngeles-autograph600.png',
        id: 27060,
    },
    {
        state: 'California',
        title: 'Girl Scouts Heart of Central California',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-HeartOfCentralCalifornia_Service-autograph600.png',
        id: 27196,
    },
    {
        state: 'California',
        title: 'Girl Scouts of Northern California',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-NorthernCalifornia-autograph600.png',
        id: 27062,
    },
    {
        state: 'California',
        title: 'Girl Scouts of Orange County',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-OrangeCounty-autograph600.png',
        id: 27063,
    },
    {
        state: 'California',
        title: 'Girl Scouts San Diego',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-SanDiego-autograph600.png',
        id: 27064,
    },
    {
        state: 'California',
        title: 'Girl Scouts of San Gorgonio Council',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-SanGorgonio-autograph600.png',
        id: 27065,
    },
    {
        state: 'Colorado',
        title: 'Girl Scouts of Colorado',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-Colorado-autograph600.png',
        id: 27066,
    },
    {
        state: 'Connecticut',
        title: 'Girl Scouts of Connecticut',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-Connecticut-autograph600.png',
        id: 27067,
    },
    {
        state: 'Delaware',
        title: 'Girl Scouts of the Chesapeake Bay Council',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-TheChesapeakeBay-autograph600.png',
        id: 27068,
    },
    {
        state: 'District of Columbia',
        title: "Girl Scout Council of the Nation's Capital",
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-NationsCapital-autograph600.png',
        id: 27069,
    },
    {
        state: 'Florida',
        title: 'Girl Scouts of Citrus Council',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-Citrus-autograph600.png',
        id: 27070,
    },
    {
        state: 'Florida',
        title: 'Girl Scout Council of the Florida Panhandle',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-GatewayCouncil-autograph600.png',
        id: -1,
    },
    {
        state: 'Florida',
        title: 'Girl Scouts of Gateway Council',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-GatewayCouncil-autograph600.png',
        id: 27071,
    },
    {
        state: 'Florida',
        title: 'Girl Scouts of Gulfcoast Florida',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-GulfcoastFlorida-autograph600.png',
        id: 27072,
    },
    {
        state: 'Florida',
        title: 'Girl Scouts of Southeast Florida',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-SoutheastFlorida-autograph600.png',
        id: 27073,
    },
    {
        state: 'Florida',
        title: 'Girl Scout Council of Tropical Florida',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-TropicalFlorida-autograph600.png',
        id: 27074,
    },
    {
        state: 'Florida',
        title: 'Girl Scouts of West Central Florida',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-WestCentralFlorida-autograph600.png',
        id: 27075,
    },
    {
        state: 'Georgia',
        title: 'Girl Scouts of Greater Atlanta',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-GreaterAtlanta-autograph600.png',
        id: 27076,
    },
    {
        state: 'Georgia',
        title: 'Girl Scouts of Greater Mississippi',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-GreaterMississippi-autograph600.png',
        id: 27078,
    },
    {
        state: 'Georgia',
        title: 'Girl Scouts of Historic Georgia',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-HistoricGeorgia-autograph600.png',
        id: 27077,
    },
    {
        state: 'Hawaii',
        title: 'Girl Scouts of Hawaii',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-Hawaii-autograph600.png',
        id: 27079,
    },
    {
        state: 'Idaho',
        title: 'Girl Scouts of Eastern Washington and Northern Idaho',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-EasternWashingtonAndNorthernIdaho-autograph600.png',
        id: 27197,
    },
    {
        state: 'Idaho',
        title: 'Girl Scouts of Silver Sage',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-SilverSage-autograph600.png',
        id: 27080,
    },
    {
        state: 'Illinois',
        title: 'Girl Scouts of Central Illinois',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-CentralIllinois-autograph600.png',
        id: 27082,
    },
    {
        state: 'Illinois',
        title: 'Girl Scouts of Greater Chicago and Northwest Indiana',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-GreaterChicagoAndNorthwestIndiana-autograph600.png',
        id: 27198,
    },
    {
        state: 'Illinois',
        title: 'Girl Scouts of Northern Illinois',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-NorthernIllinois-autograph600.png',
        id: 27084,
    },
    {
        state: 'Illinois',
        title: 'Girl Scouts of Southern Illinois',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-SouthernIllinois-autograph600.png',
        id: 27085,
    },
    {
        state: 'Indiana',
        title: 'Girl Scouts of Central Indiana',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-CentralIndiana-autograph600.png',
        id: 27086,
    },
    {
        state: 'Indiana',
        title: 'Girl Scouts of Northern Indiana-Michiana',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-NorthernIndianaMichiana-autograph600.png',
        id: 27087,
    },
    {
        state: 'Indiana',
        title: 'Girl Scouts of Southwest Indiana',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-SouthwestIndiana-autograph600.png',
        id: 27088,
    },
    {
        state: 'Iowa',
        title: 'Girl Scouts of Eastern Iowa and Western Illinois',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-EasternIowaAndWesternIllinois-autograph600.png',
        id: 27090,
    },
    {
        state: 'Iowa',
        title: 'Girl Scouts of Greater Iowa',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-GreaterIowa-autograph600.png',
        id: 27089,
    },
    {
        state: 'Kansas',
        title: 'Girl Scouts of Kansas Heartland',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-KansasHeartland-autograph600.png',
        id: 27091,
    },
    {
        state: 'Kansas',
        title: 'Girl Scouts of Northeast Kansas and Northwest Missouri',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-NEKansasAndNWMissouri-autograph600.png',
        id: 27092,
    },
    {
        state: 'Kentucky',
        title: 'Girl Scouts of Kentuckiana',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-Kentuckiana-autograph600.png',
        id: 27093,
    },
    {
        state: 'Kentucky',
        title: "Girl Scouts of Kentucky's Wilderness Road",
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-KentuckysWildernessRoad-autograph600.png',
        id: 27094,
    },
    {
        state: 'Louisiana',
        title: 'Girl Scouts Louisiana East',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-LouisianaEast-autograph600.png',
        id: 27095,
    },
    {
        state: 'Louisiana',
        title: 'Girl Scouts of Louisiana–Pines to the Gulf',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-LouisianaPinesToTheGulf-autograph600.png',
        id: 27096,
    },
    {
        state: 'Maine',
        title: 'Girl Scouts of Maine',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-Maine-autograph600.png',
        id: 27097,
    },
    {
        state: 'Maryland',
        title: 'Girl Scouts of Central Maryland',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-CentralMaryland-autograph600.png',
        id: 27098,
    },
    {
        state: 'Maryland',
        title: 'Girl Scouts of the Chesapeake Bay Council',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-TheChesapeakeBay-autograph600.png',
        id: 27068,
    },
    {
        state: 'Maryland',
        title: "Girl Scout Council of the Nation's Capital",
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-NationsCapital-autograph600.png',
        id: 27069,
    },
    {
        state: 'Massachusetts',
        title: 'Girl Scouts of Central and Western Massachusetts',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-CentralAndWesternMassachusetts-autograph600.png',
        id: 27200,
    },
    {
        state: 'Massachusetts',
        title: 'Girl Scouts of Eastern Massachusetts',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-EasternMassachusetts-autograph600.png',
        id: 27102,
    },
    {
        state: 'Michigan',
        title: 'Girl Scouts Heart of Michigan',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-HeartOfMichigan-autograph600.png',
        id: 27103,
    },
    {
        state: 'Michigan',
        title: 'Girl Scouts of Michigan Shore to Shore',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-MichiganShoreToShore-autograph600.png',
        id: 27104,
    },
    {
        state: 'Michigan',
        title: 'Girl Scouts of Southeastern Michigan',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-SoutheasternMichigan-autograph600.png',
        id: 27105,
    },
    {
        state: 'Minnesota',
        title: 'Girl Scouts of Minnesota and Wisconsin Lakes and Pines',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-LakesAndPines-autograph600.png',
        id: 27106,
    },
    {
        state: 'Minnesota',
        title: 'Girl Scouts of Minnesota and Wisconsin River Valleys',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-RiverValleys-autograph600.png',
        id: 27107,
    },
    {
        state: 'Mississippi',
        title: 'Girl Scouts of Greater Mississippi',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-GreaterMississippi-autograph600.png',
        id: 27078,
    },
    {
        state: 'Missouri',
        title: 'Girl Scouts of Eastern Missouri',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-EasternMissouri-autograph600.png',
        id: 27110,
    },
    {
        state: 'Missouri',
        title: 'Girl Scouts of the Missouri Heartland',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-MissouriHeartland-autograph600.png',
        id: 27109,
    },
    {
        state: 'Missouri',
        title: 'Girl Scouts of Northeast Kansas and Northwest Missouri',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-NEKansasAndNWMissouri-autograph600.png',
        id: 27092,
    },
    {
        state: 'Montana',
        title: 'Girl Scouts of Montana and Wyoming',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-MontanaAndWyoming-autograph600.png',
        id: 27112,
    },
    {
        state: 'Nebraska',
        title: 'Girl Scouts Spirit of Nebraska',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-SpiritOfNebraska-autograph600.png',
        id: 27113,
    },
    {
        state: 'Nevada',
        title: 'Girl Scouts of the Sierra Nevada',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-SierraNevada-autograph600.png',
        id: 27115,
    },
    {
        state: 'Nevada',
        title: 'Girl Scouts of Southern Nevada',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-SouthernNevada-autograph600.png',
        id: 27114,
    },
    {
        state: 'New Hampshire',
        title: 'Girl Scouts of the Green and White Mountains',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-GreenAndWhiteMountains-autograph600.png',
        id: 27116,
    },
    {
        state: 'New Jersey',
        title: 'Girl Scouts of Central and Southern New Jersey',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-Central&SouthernNewJersey-autograph600.png',
        id: 27117,
    },
    {
        state: 'New Jersey',
        title: 'Girl Scouts Heart of New Jersey',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-HeartOfNewJersey-autograph600.png',
        id: 27118,
    },
    {
        state: 'New Jersey',
        title: 'Girl Scouts of the Jersey Shore',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-JerseyShore-autograph600.png',
        id: 27120,
    },
    {
        state: 'New Jersey',
        title: 'Girl Scouts of Northern New Jersey',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-NorthernNewJersey-autograph600.png',
        id: 27119,
    },
    {
        state: 'New Mexico',
        title: 'Girl Scouts of New Mexico Trails',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-NewMexicoTrails-autograph600.png',
        id: 27121,
    },
    {
        state: 'New York',
        title: 'Girl Scouts of Greater New York',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-GreaterNewYork-autograph600.png',
        id: 27122,
    },
    {
        state: 'New York',
        title: 'Girl Scouts Heart of the Hudson',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-HeartOfTheHudson-autograph600.png',
        id: 27123,
    },
    {
        state: 'New York',
        title: 'Girl Scouts of Nassau County',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-NassauCounty-autograph600.png',
        id: 27124,
    },
    {
        state: 'New York',
        title: 'Girl Scouts of Northeastern New York',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-NortheasternNewYork-autograph600.png',
        id: 27125,
    },
    {
        state: 'New York',
        title: 'Girl Scouts of NYPENN Pathways',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-NypennPathways-autograph600.png',
        id: 27126,
    },
    {
        state: 'New York',
        title: 'Girl Scouts of Suffolk County',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-SuffolkCounty-autograph600.png',
        id: 27127,
    },
    {
        state: 'New York',
        title: 'Girl Scouts of Western New York',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-WesternNewYork-autograph600.png',
        id: 27128,
    },
    {
        state: 'North Carolina',
        title: 'Girl Scouts Carolinas Peaks to Piedmont',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-CarolinasPeaksToPiedmont-autograph600.png',
        id: 27129,
    },
    {
        state: 'North Carolina',
        title: "Girl Scouts, Hornets' Nest Council",
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-HornetsNest-autograph600.png',
        id: 27130,
    },
    {
        state: 'North Carolina',
        title: 'Girl Scouts - North Carolina Coastal Pines',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-NorthCarolinaCoastalPines-autograph600.png',
        id: -1,
    },
    {
        state: 'North Dakota',
        title: 'Girl Scouts - Dakota Horizons',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-DakotaHorizons-autograph600.png',
        id: 27132,
    },
    {
        state: 'Ohio',
        title: 'Girl Scouts of North East Ohio',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-NorthEastOhio-autograph600.png',
        id: 27133,
    },
    {
        state: 'Ohio',
        title: "Girl Scouts of Ohio's Heartland",
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-OhiosHeartland-autograph600.png',
        id: 27134,
    },
    {
        state: 'Ohio',
        title: 'Girl Scouts of Western Ohio',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-WesternOhio-autograph600.png',
        id: 27135,
    },
    {
        state: 'Oklahoma',
        title: 'Girl Scouts of Eastern Oklahoma',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-EasternOklahoma-autograph600.png',
        id: 27137,
    },
    {
        state: 'Oklahoma',
        title: 'Girl Scouts - Western Oklahoma',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-WesternOklahoma-autograph600.png',
        id: 27136,
    },
    {
        state: 'Oregon',
        title: 'Girl Scouts of Oregon and Southwest Washington',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-Oregon&SWWashington-autograph600.png',
        id: 27138,
    },
    {
        state: 'Pennsylvania',
        title: 'Girl Scouts of Eastern Pennsylvania',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-EasternPennsylvania-autograph600.png',
        id: 27140,
    },
    {
        state: 'Pennsylvania',
        title: 'Girl Scouts in the Heart of Pennsylvania',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-HeartOfPennsylvania-autograph600.png',
        id: 27139,
    },
    {
        state: 'Pennsylvania',
        title: 'Girl Scouts of Western Pennsylvania',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-WesternPennsylvania-autograph600.png',
        id: 27141,
    },
    {
        state: 'Rhode Island',
        title: 'Girl Scouts of Southeastern New England',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-SoutheasternNewEngland-autograph600.png',
        id: 27142,
    },
    {
        state: 'South Carolina',
        title: 'Girl Scouts of Eastern South Carolina',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-EasternSouthCarolina-autograph600.png',
        id: 27143,
    },
    {
        state: 'South Carolina',
        title: 'Girl Scouts of South Carolina - Mountains to Midlands',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-SouthCarolinaMountainsToMidlands-autograph600.png',
        id: 27144,
    },
    {
        state: 'South Dakota',
        title: 'Girl Scouts - Dakota Horizons',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-DakotaHorizons-autograph600.png',
        id: 27132,
    },
    {
        state: 'Tennessee',
        title: 'Girl Scouts Heart of the South',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-HeartOfTheSouth-autograph600.png',
        id: 27148,
    },
    {
        state: 'Tennessee',
        title: 'Girl Scouts of Middle Tennessee',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-MiddleTennessee-autograph600.png',
        id: 27146,
    },
    {
        state: 'Tennessee',
        title: 'Girl Scouts of the Southern Appalachians',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-SouthernAppalachians-autograph600.png',
        id: 27147,
    },
    {
        state: 'Texas',
        title: 'Girl Scouts of Central Texas',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-CentralTexas-autograph600.png',
        id: 27149,
    },
    {
        state: 'Texas',
        title: 'Girl Scouts of Northeast Texas',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-NortheastTexas-autograph600.png',
        id: 27158,
    },
    {
        state: 'Texas',
        title: 'Girl Scouts of San Jacinto Council',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-SanJacinto-autograph600.png',
        id: 27159,
    },
    {
        state: 'Texas',
        title: 'Girl Scouts of Southwest Texas',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-SouthwestTexas-autograph600.png',
        id: 27160,
    },
    {
        state: 'Texas',
        title: 'Girl Scouts of Texas Oklahoma Plains',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-TexasOklahomaPlains-autograph600.png',
        id: 27161,
    },
    {
        state: 'Utah',
        title: 'Girl Scouts of Utah',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-Utah-autograph600.png',
        id: 27162,
    },
    {
        state: 'Vermont',
        title: 'Girl Scouts of the Green and White Mountains',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-GreenAndWhiteMountains-autograph600.png',
        id: 27116,
    },
    {
        state: 'Virginia',
        title: 'Girl Scouts of the Colonial Coast',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-ColonialCoast-autograph600.png',
        id: 27165,
    },
    {
        state: 'Virginia',
        title: 'Girl Scouts of the Commonwealth of Virginia',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-TheCommonwealthOfVirginia-autograph600.png',
        id: 27163,
    },
    {
        state: 'Virginia',
        title: "Girl Scouts Nation's Capital",
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-NationsCapital-autograph600.png',
        id: -1,
    },
    {
        state: 'Virginia',
        title: 'Girl Scouts of Virginia Skyline Council',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-VirginiaSkyline-autograph600.png',
        id: 27164,
    },
    {
        state: 'Washington',
        title: 'Girl Scouts of Eastern Washington and Northern Idaho',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-EasternWashingtonAndNorthernIdaho-autograph600.png',
        id: 27197,
    },
    {
        state: 'Washington',
        title: 'Girl Scouts of Western Washington',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-WesternWashington-autograph600.png',
        id: 27166,
    },
    {
        state: 'West Virginia',
        title: 'Girl Scouts of Black Diamond Council',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-BlackDiamond-autograph600.png',
        id: 27168,
    },
    {
        state: 'Wisconsin',
        title: 'Girl Scouts of Manitou Council',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-Manitou-autograph600.png',
        id: 27169,
    },
    {
        state: 'Wisconsin',
        title: 'Girl Scouts of the Northwestern Great Lakes',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-NorthwesternGreatLakes-autograph600.png',
        id: 27172,
    },
    {
        state: 'Wisconsin',
        title: 'Girl Scouts of Wisconsin - Badgerland Council',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-WisconsinBadgerland-autograph600.png',
        id: 27170,
    },
    {
        state: 'Wisconsin',
        title: 'Girl Scouts of Wisconsin Southeast',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-WisconsinSoutheast-autograph600.png',
        id: 27171,
    },
    {
        state: 'Wyoming',
        title: 'Girl Scouts of Montana and Wyoming',
        productImageUrl: 'https://chc-sharing.s3.amazonaws.com/Playground/GirlScoutsAutographFrames/600px/Girl-MontanaAndWyoming-autograph600.png',
        id: 27112,
    },
];
